import React, { useEffect, useState } from "react";
import handIcon from "../../../assets/hand-icon.svg";
import { useSelector } from "react-redux";
import { getIsScoreRevealAnimationVisible } from "../../../store/selectors/ludoboardSelectors";
import ImageComponent from "../../ImageComponent";
import { getWidth } from "../../../utils/relativeSizes";

interface IKukriHandAnimation {
  duration?: number;
  containerStyle?: React.CSSProperties;
}

const KukriHandAnimation = ({ duration = 800, containerStyle }: IKukriHandAnimation) => {
  const x1 = 100;
  const y1 = 100;
  const x2 = 0;
  const y2 = 0;

  const [visible, setVisible] = useState<boolean>(false);
  const [position, setPosition] = useState({ x: x1, y: y1 });
  const isScoreRevealAnimationVisible = useSelector(getIsScoreRevealAnimationVisible);

  const startAnimation = () => {
    setPosition({ x: x1, y: y1 });
    setVisible(true);

    const animateStep = (step: number) => {
      if (step > 4) {
        setVisible(false);
        return;
      }

      const nextPosition = step % 2 === 0 ? { x: x1, y: y1 } : { x: x2, y: y2 };

      setTimeout(() => {
        setPosition(nextPosition);
        animateStep(step + 1);
      }, duration);
    };

    animateStep(1);
  };

  useEffect(() => {
    if (isScoreRevealAnimationVisible) {
      startAnimation();
    }
  }, [isScoreRevealAnimationVisible]);

  if (!visible) return null;

  return (
    <div
      style={{
        ...containerStyle,
        position: "absolute",
        left: position.x,
        top: position.y,
        transition: `left ${duration}ms ease-in-out, top ${duration}ms ease-in-out`,
      }}
    >
      <ImageComponent
        src={handIcon}
        alt="Hand Animation"
        style={{
          height: getWidth(50),
          width: getWidth(50),
        }}
      />
    </div>
  );
};

export default React.memo(KukriHandAnimation);
